module.exports = __webpack_public_path__ + "static/media/eventNote.f629fdab.svg";